"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentTemplateModel = void 0;
var queryString_1 = require("../helpers/queryString");
var DocumentTemplateModel = /** @class */ (function () {
    function DocumentTemplateModel($http, APPURL) {
        this.$http = $http;
        this.APPURL = APPURL;
        this.URLS = {
            TEMPLATES: "".concat(APPURL, "/api/v1/documents/templates"),
            DOCUMENTS: "".concat(APPURL, "/api/v1/documents"),
            GENERATE: "".concat(APPURL, "/api/v1/documents/generate"),
        };
        this.data = [];
        this.extract = this.extract.bind(this);
        this.cacheResults = this.cacheResults.bind(this);
    }
    DocumentTemplateModel.prototype.extract = function (result) {
        return result.data;
    };
    DocumentTemplateModel.prototype.cacheResults = function (result) {
        this.data = this.extract(result);
        return this.data;
    };
    // Helper to recursively append nested objects/arrays to FormData
    // This is needed because Laravel expects bracket notation for nested data in multipart/form-data
    DocumentTemplateModel.prototype.appendToFormData = function (formData, key, value) {
        var _this = this;
        if (value === null || value === undefined) {
            return;
        }
        if (Array.isArray(value)) {
            value.forEach(function (item, index) {
                _this.appendToFormData(formData, "".concat(key, "[").concat(index, "]"), item);
            });
        }
        else if (typeof value === "object" && !(value instanceof File)) {
            var obj_1 = value;
            Object.keys(obj_1).forEach(function (nestedKey) {
                _this.appendToFormData(formData, "".concat(key, "[").concat(nestedKey, "]"), obj_1[nestedKey]);
            });
        }
        else if (typeof value === "boolean") {
            formData.append(key, value ? "1" : "0");
        }
        else {
            formData.append(key, String(value));
        }
    };
    // Template methods
    DocumentTemplateModel.prototype.getTemplates = function (params) {
        var url = params
            ? "".concat(this.URLS.TEMPLATES, "?").concat((0, queryString_1.toQueryString)(params))
            : this.URLS.TEMPLATES;
        return this.$http.get(url).then(this.cacheResults);
    };
    DocumentTemplateModel.prototype.getTemplate = function (id) {
        return this.$http
            .get("".concat(this.URLS.TEMPLATES, "/").concat(id))
            .then(this.cacheResults);
    };
    DocumentTemplateModel.prototype.createTemplate = function (data) {
        var _this = this;
        var formData = new FormData();
        Object.keys(data).forEach(function (key) {
            if (key === "annotations") {
                // Use bracket notation for nested data - Laravel expects this format in multipart/form-data
                _this.appendToFormData(formData, key, data[key]);
            }
            else if (key === "pdf_file" && data[key]) {
                formData.append(key, data[key]);
            }
            else if (data[key] !== undefined) {
                formData.append(key, data[key]);
            }
        });
        return this.$http
            .post(this.URLS.TEMPLATES, formData, {
            headers: { "Content-Type": undefined },
        })
            .then(this.cacheResults);
    };
    DocumentTemplateModel.prototype.updateTemplate = function (id, data) {
        return this.$http
            .put("".concat(this.URLS.TEMPLATES, "/").concat(id), data)
            .then(this.cacheResults);
    };
    DocumentTemplateModel.prototype.deleteTemplate = function (id) {
        return this.$http
            .delete("".concat(this.URLS.TEMPLATES, "/").concat(id))
            .then(this.cacheResults);
    };
    DocumentTemplateModel.prototype.updateTemplateField = function (templateId, fieldId, data) {
        return this.$http
            .put("".concat(this.URLS.TEMPLATES, "/").concat(templateId, "/fields/").concat(fieldId), data)
            .then(this.cacheResults);
    };
    DocumentTemplateModel.prototype.uploadPDF = function (file) {
        var formData = new FormData();
        formData.append("pdf_file", file);
        return this.$http
            .post("".concat(this.URLS.TEMPLATES, "/upload"), formData, {
            headers: { "Content-Type": undefined },
        })
            .then(this.cacheResults);
    };
    // Document methods
    DocumentTemplateModel.prototype.generateDocument = function (data) {
        return this.$http
            .post(this.URLS.GENERATE, data)
            .then(this.cacheResults);
    };
    DocumentTemplateModel.prototype.getDocuments = function (params) {
        var url = params
            ? "".concat(this.URLS.DOCUMENTS, "?").concat((0, queryString_1.toQueryString)(params))
            : this.URLS.DOCUMENTS;
        return this.$http
            .get(url)
            .then(this.cacheResults);
    };
    DocumentTemplateModel.prototype.getDocument = function (id) {
        return this.$http
            .get("".concat(this.URLS.DOCUMENTS, "/").concat(id))
            .then(this.cacheResults);
    };
    DocumentTemplateModel.prototype.getUserDocuments = function (userId, params) {
        var url = params
            ? "".concat(this.URLS.DOCUMENTS, "/users/").concat(userId, "/documents?").concat((0, queryString_1.toQueryString)(params))
            : "".concat(this.URLS.DOCUMENTS, "/users/").concat(userId, "/documents");
        return this.$http.get(url).then(this.cacheResults);
    };
    DocumentTemplateModel.prototype.updateDocumentField = function (documentId, fieldName, data) {
        return this.$http
            .put("".concat(this.URLS.DOCUMENTS, "/").concat(documentId, "/fields/").concat(fieldName), data)
            .then(this.cacheResults);
    };
    DocumentTemplateModel.prototype.submitDocument = function (id, data) {
        return this.$http
            .post("".concat(this.URLS.DOCUMENTS, "/").concat(id, "/submit"), data || {})
            .then(this.cacheResults);
    };
    DocumentTemplateModel.prototype.archiveDocument = function (id) {
        return this.$http
            .post("".concat(this.URLS.DOCUMENTS, "/").concat(id, "/archive"), {})
            .then(this.cacheResults);
    };
    DocumentTemplateModel.prototype.sendReminder = function (id, data) {
        return this.$http
            .post("".concat(this.URLS.DOCUMENTS, "/").concat(id, "/remind"), data)
            .then(this.cacheResults);
    };
    // Utility methods
    DocumentTemplateModel.prototype.validateTemplate = function (templateData) {
        var errors = [];
        if (!templateData.name || templateData.name.trim() === "") {
            errors.push("Template name is required");
        }
        if (!templateData.annotations || templateData.annotations.length === 0) {
            errors.push("At least one field is required");
        }
        if (templateData.annotations) {
            var fieldNames_1 = new Set();
            templateData.annotations.forEach(function (annotation, index) {
                if (!annotation.fieldName || annotation.fieldName.trim() === "") {
                    errors.push("Field ".concat(index + 1, " must have a name"));
                }
                if (fieldNames_1.has(annotation.fieldName)) {
                    errors.push("Duplicate field name: ".concat(annotation.fieldName));
                }
                fieldNames_1.add(annotation.fieldName);
                if (!annotation.label || annotation.label.trim() === "") {
                    errors.push("Field ".concat(annotation.fieldName, " must have a label"));
                }
                if (!annotation.assignableTo ||
                    annotation.assignableTo.length === 0) {
                    errors.push("Field ".concat(annotation.fieldName, " must be assignable to at least one role"));
                }
                if (annotation.type === "select" &&
                    (!annotation.properties.options ||
                        annotation.properties.options.length === 0)) {
                    errors.push("Select field ".concat(annotation.fieldName, " must have at least one option"));
                }
            });
        }
        return {
            valid: errors.length === 0,
            errors: errors,
        };
    };
    DocumentTemplateModel.prototype.getFieldsByRole = function (template, role) {
        return template.annotations.filter(function (annotation) {
            return annotation.assignableTo.includes(role);
        });
    };
    DocumentTemplateModel.prototype.calculateCompletionPercentage = function (document, userFields) {
        if (!userFields.length) {
            return 0;
        }
        var completedFields = userFields.filter(function (fieldName) {
            return document.field_values[fieldName] !== undefined &&
                document.field_values[fieldName] !== null &&
                document.field_values[fieldName] !== "";
        });
        return Math.round((completedFields.length / userFields.length) * 100);
    };
    return DocumentTemplateModel;
}());
exports.DocumentTemplateModel = DocumentTemplateModel;
DocumentTemplateModel.$inject = ["$http", "APPURL"];
exports.default = DocumentTemplateModel;
